const MostoLevedurado= {
  title : "Mosto Levedurado",
  props: [
    { calc: '', mapping: "in|@|MostoLevedurado|Atributos|W" },
    { calc: '', mapping: "in|@|MostoLevedurado|Atributos|T" },
    { calc: '', mapping: "ci|@|MostoLevedurado|Caldo|fracaoMassica" },
    { caption: '°INPM', unit: 'NA', calc: '', mapping: "ci|@|MostoLevedurado|Etanol|fracaoMassica" },
    { calc: '', mapping: "ci|@|MostoLevedurado|Levedura|fracaoMassica" },
    { calc: '', mapping: "ci|@|MostoLevedurado|Impureza|fracaoMassica" },
    { calc: '', mapping: "ci|@|MostoLevedurado|Glicerol|fracaoMassica" }
  ]
}

const Fermento= {
  title : "Fermento",
  props: [
    { calc: '', mapping: "in|@|Fermento|Atributos|W" },
    { calc: '', mapping: "ci|@|Fermento|Caldo|fracaoMassica" },
    { caption: '°INPM', unit: 'NA', calc: '', mapping: "ci|@|Fermento|Etanol|fracaoMassica" },
    { caption: 'Levedura', calc: "(((in|Fermentacao|RBB_701|Fermento|Atributos|W * (ci|Fermentacao|RBB_701|Fermento|Etanol|fracaoMassica / 100)) / 778.5) / ( in|Fermentacao|RBB_701|Fermento|Atributos|W /(in|Fermentacao|RBB_701|Fermento|Atributos|W * 1000 /in|Fermentacao|RBB_701|Fermento|Atributos|Wvol))) * 100", mapping:"in|@|Fermento|Atributos|WVol" },
    { calc: '', mapping: "ci|@|Fermento|Impureza|fracaoMassica" },
    { calc: '', mapping: "ci|@|Fermento|Glicerol|fracaoMassica" }
  ]
}

const CremeLevedurado= {
  title : "Creme Levedurado",
  props: [
    { calc: '', mapping: "in|@|CremeLevedurado|Atributos|W" },
    { calc: '', mapping: "ci|@|CremeLevedurado|Caldo|fracaoMassica" },
    { caption: '°INPM', unit: 'NA', calc: '', mapping: "ci|@|CremeLevedurado|Etanol|fracaoMassica" },
    { calc: '', mapping: "ci|@|CremeLevedurado|Levedura|fracaoMassica" },
    { calc: '', mapping: "ci|@|CremeLevedurado|Impureza|fracaoMassica" },
    { calc: '', mapping: "ci|@|CremeLevedurado|Glicerol|fracaoMassica" }
  ]
}

const VinhoBruto= {
  title : "Vinho Bruto",
  props: [
    { calc: '', mapping: "in|@|VinhoBruto|Atributos|W" },
    { calc: '', mapping: "in|@|VinhoBruto|Atributos|T" },
    { calc: '', mapping: "ci|@|VinhoBruto|Caldo|fracaoMassica" },
    { caption: '°INPM', unit: 'NA', calc: '', mapping: "ci|@|VinhoBruto|Etanol|fracaoMassica" },
    { calc: '', caption: '°GL', unit: '°', mapping: "op|@|GL_Dorna" },
    { calc: '', mapping: "ci|@|VinhoBruto|Levedura|fracaoMassica" },
    { calc: '', mapping: "ci|@|VinhoBruto|Impureza|fracaoMassica" },
    { calc: '', mapping: "ci|@|VinhoBruto|Glicerol|fracaoMassica" }
  ]
}

const CurrentFermentation = [
  MostoLevedurado,
  Fermento,
  CremeLevedurado,
  VinhoBruto
]

export default CurrentFermentation